import filesApiFactory from '@/api/files.api';

const API = filesApiFactory('syncblobs');

const state = {
  syncedFileSearchResults: [],
};

const getters = {
  syncedFileSearchResults: (state) => state.syncedFileSearchResults,
};

const mutations = {
  setSyncedFileSearchResults: (state, syncedFileSearchResults) => {
    state.syncedFileSearchResults = syncedFileSearchResults;
  },
};

const actions = {
  async uploadSynced({commit}, data) {
    const response = await API.upload(data);
    return response.data;
  },
  async editSynced({commit}, payload) {
    const response = await API.edit(payload.id, payload.data);
    return response.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
